/* Observe media once; keep playback work local to clips near the viewport. */
(() => {
  const near = new Set(), bound = new WeakSet();
  function sync(v) {
    if (!v.isConnected || document.hidden || !near.has(v) || (v.style.opacity || getComputedStyle(v).opacity) === '0') { v.pause(); return; }
    if (!v.__on) { v.__on = 1; v.preload = 'auto'; if (v.readyState === 0 && !v.currentSrc) v.load(); }
    v.muted = true; v.playsInline = true;
    // Interactive spin has its own pointer/keyboard controller.
    if (v.closest('#mp-spin')?.style.cursor === 'grabbing') return;
    if (v.paused) v.play().catch(() => {});
  }
  const io = new IntersectionObserver(entries => entries.forEach(({target:v,isIntersecting}) => {
    if (isIntersecting) near.add(v); else near.delete(v); sync(v);
  }), {rootMargin:'500px 0px'});
  const style = new MutationObserver(records => { for (const v of new Set(records.map(r=>r.target))) sync(v); });
  function bind(root) {
    const videos = root.matches?.('video') ? [root] : [...(root.querySelectorAll?.('video') || [])];
    for (const v of videos) { if (bound.has(v)) continue; bound.add(v); v.addEventListener('loadeddata', () => sync(v)); io.observe(v); style.observe(v,{attributes:true,attributeFilter:['style']}); }
  }
  bind(document);
  new MutationObserver(records => records.forEach(r => r.addedNodes.forEach(n => { if(n.nodeType===1) bind(n); }))).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('visibilitychange',()=>near.forEach(sync));
})();
